import './src/styles/custom.css';
import "bootstrap/dist/css/bootstrap.min.css";
import CustomLayout from './wrapPageElement';

export const wrapPageElement = CustomLayout;